import Component from '../../UM-Base/components/Component';
import { getTripPlannerUrl, isMode, messageBoxAnswerWait, getIdServerUrl, isTest, TripPlannerMode } from '../../UM-Base/lib/TripPlannerHelper';
import { getConfig, getAccessTokenOrSignin, UserManager, logoutLocal, disableButtonsTemporarily, setRedirectPage } from '../../UM-Base/lib/OidcHelper';

export default class TripPlanModal extends Component {

	load() {
    window.loadedIframe = false;
    this.frameMessagesListener(this);
    $('#tripplan-mobile-btn').on('click', this.tripPlanButtonClick.bind(this));
    $('#tripplan-desktop-btn').on('click', this.tripPlanButtonClick.bind(this));
    $('#tripplan-manage-btn').on('click', this.tripPlanButtonClick.bind(this));

    this.initTripPlanButtons();
		super.load();

    // listen for bootstrap modal close event start
    $('#trip-modal').on('hidden.bs.modal', function () {
      sessionStorage.removeItem('modalOpen_Plan');
      sessionStorage.removeItem('signinPageVisited');
    });

    // console.log('!!getSharedTripFromURL(): ', !!getSharedTripFromURL());
    // if shared trip present
    if (!!getSharedTripFromURL()) {
      sessionStorage.removeItem('signinPageVisited');
      // if you login the shared trip is in the redirect URL so will use that on return
      sessionStorage.setItem('sharedTripId', getSharedTripFromURL());
      // How many trips can a user have? is there a risk a shared trip could overwrite one?
      this.openTripPlanIframe();
    }
  }

  tripPlanButtonClick(event) {
    if (!!event) {
      event.preventDefault()
    }
    sessionStorage.removeItem('signinPageVisited');
    this.openTripPlanIframe();
  }

  initTripPlanButtons() {
    // if TripPlanModal was open, re-open it

    // checks if and when signin or logout pages were visited
    // use to prevent redirect loops on back button from id-server page
    const logoutPageVisited = sessionStorage.getItem('logoutPageVisited');
    if (!!logoutPageVisited) {
      console.log('logoutPageVisited value: ', logoutPageVisited);
    }

    if (!!window.SAredirectPageForOidc) { // location.pathname.includes('-oidc') // Set by RedirectLandingPage.cshtml, preferably this file wouldn't load on oidc redirect pgs.
      return;
    }

    const lastLogin = sessionStorage.getItem('lastLogin');
    if (!!lastLogin) {  // if there is a last login
      // const now = new Date().getTime();  // returns time in milliseconds  // we set 'now' but didn't use it.
      disableButtonsTemporarily(lastLogin);
    }

    // if TripPlan modal was left open then re-open
    const signinPageVisited = sessionStorage.getItem('signinPageVisited');
    if (!!signinPageVisited) {
      console.log('signinPageVisited value: ', signinPageVisited);
      // this exists on success
    }
    const modalLeftOpen_Plan = sessionStorage.getItem('modalOpen_Plan');
    const modalLeftOpen_Add = sessionStorage.getItem('modalOpen_Add');
    if (!!signinPageVisited && !!modalLeftOpen_Plan) {
      this.openTripPlanIframe();
      // $('#addToTripModal').modal('hide');
      // $('#trip-modal').modal('show');
    }

    if (!signinPageVisited || !(!!modalLeftOpen_Plan || !!modalLeftOpen_Add)) { // if signin page not visited or either TripPlanner or AddToTrip modals are not truthy
      // clean modal open session storage
      sessionStorage.removeItem('signinPageVisited');
      sessionStorage.removeItem('modalOpen_Plan');
    }
  }

  async openTripPlanIframe() {
    sessionStorage.setItem('modalOpen_Plan', 'tripplan');

    setRedirectPage();

    //const config = getConfig(window.location);
    //const oidcUserManager = new UserManager(config);
    // if no mode set open messageBox
    if(isMode('')) {
      const answer = await messageBoxAnswerWait();
      if(!answer)
        return;
    }
    // if mode sandbox open TripPlanModal
    if(isMode(TripPlannerMode.sandbox)) {
      openTripPlanModal();
      return;
    }

    const config = getConfig(window.location);
    const oidcUserManager = new UserManager(config);

    // check if user is logged in
    const token = await getAccessTokenOrSignin(oidcUserManager);

    // check if user is logged in
    if (token == null) {
      console.log('no token.');
    } else {
      // got token so show trip planner in modal.
      console.log('got token!');
      openTripPlanModal(); // show modal
    }
  }

  // receive & filter messages from iframe
  receiveMessage( event ) {
    const addTest = isTest() ? '-test' : '';
    const allowedOrigins = [
      `https://trip${addTest}.southaustralia.com`,
      `https://id${addTest}.southaustralia.com`,
    ];

    if (typeof event.data === 'string' && allowedOrigins.includes(event.origin)) {
      console.log(`receiveMessage event origin: ${event.origin}`, event.data);
      actionMessage(event.data);
    }
  }

  // listen for a close event from iframe
  frameMessagesListener() {
    console.log('start frameMessagesListener');
    window.addEventListener("message", (event) => {
      debugLog("LoggedOut message: ", event.data);
      this.receiveMessage(event);
    }, false);
  }
}

/* These functions are outside the TripPlanModal Class. */
/* class objects won't be accessible via "this" */

// perform action
function actionMessage( action ) {
  // console.log('action: ', action);
  if (!!action) {
    action = action.toString().toLowerCase();
    if (action === 'loggedout') {
      //A message is sent from trip.southaustralia.com to confirm that the user has logged ou.
      logoutLocal();
      $('#trip-modal').modal('hide');
      sessionStorage.removeItem('modalOpen_Plan');
      console.log('action: ', action);
    }
    if (action === 'close') {
      if ($('#trip-modal').hasClass('show')) { // only if visible to avoid loops
        $('#trip-modal').modal('hide');
      }
      sessionStorage.removeItem('modalOpen_Plan');
      sessionStorage.removeItem('signinPageVisited');
      console.log('action: ', action);
    }
    if (action === 'idserver') { // if id-server loads in an iframe
      logoutLocal();
      $('#trip-modal').modal('hide');
      sessionStorage.removeItem('modalOpen_Plan');
      console.log('action: ', action);
    }
    if (action === 'login') { // redirect to login page
      $('#trip-modal').modal('hide');
      sessionStorage.removeItem('modalOpen_Plan');

      // login and redirect to ID server
      const config = getConfig(window.location);
      const oidcUserManager = new UserManager(config);
      getAccessTokenOrSignin(oidcUserManager);
      console.log('action: ', action);
    }
    if (action === 'register') { // redirect to register page
      $('#trip-modal').modal('hide');
      sessionStorage.removeItem('modalOpen_Plan');
      console.log('action: ', action);
      window.location.href = `${getIdServerUrl()}/Account/Register`;
    }
    if (action === 'search') { // if tripplanner requests a search for products to addToTrips
      sessionStorage.removeItem('modalOpen_Plan');
      console.log('action: ', action);
      window.location.href = '/search-trip-planner';
    }

    // Added parameters to action message for search
    const actionParams = action.split(':');
    if(actionParams.length <= 1)
      return;

    if (actionParams[0] === 'search') { // if tripplanner requests a search for products to addToTrips with a day selected
      sessionStorage.removeItem('modalOpen_Plan');
      sessionStorage.setItem('defaultDay', action);
      console.log('action: ', action);
      window.location.href = '/search-trip-planner';
    }
  }
}

function getSharedTripFromURL() {
  // get shared trip id to use for modal frame src
  // example: http://localhost:3000/?sh=c6711be4-4104-4d79-bd00-da7be7b4d705
  const queryParams = new URLSearchParams(window.location.search);
  const sharedTrip = queryParams.get('sh');
  // validate
  // console.log('sharedTrip: ', sharedTrip);
  if (!!sharedTrip && sharedTrip.length === 36) {
    return sharedTrip;
  }
  return '';
}

// show modal which contains the iframe
function openTripPlanModal() {
  console.log('openTripPlanModal');
  const baseUrl = getTripPlannerUrl();
  const sandboxUrl = `${baseUrl}/trip-sandbox`;
  const tripFrame = $('#trip-frame');

  // Check query string for share attempt
  // If we return from a login the redirect URL will still contain the query.
  // Example: http://localhost:3001/?sh=4bf5f345-888d-423f-8a4a-bb6e3e954b22
  let sharedTrip = getSharedTripFromURL();
  // console.debug('URL sharedTrip:', sharedTrip);

  // example: https://trip-test.southaustralia.com/share/635926d8-494e-4350-a768-edbdaff81768
  const tripShare = sharedTrip ? `/share/${sharedTrip}` : '';
  const tripPlannerUrl = `${baseUrl}${tripShare}`;
  console.log('tripPlannerUrl:', tripPlannerUrl);

  $('#addToTripModal').modal('hide'); // close addToTripModal if open

  // set iframe src if not set
  if(isMode(TripPlannerMode.sandbox) && tripFrame.attr('src') !== sandboxUrl) {
    console.log('sandbox mode URL', sandboxUrl)
    tripFrame.attr('src', sandboxUrl);
  } else if (isMode('login') && tripFrame.attr('src') !== tripPlannerUrl) {
    console.log('login mode URL', tripPlannerUrl);
    tripFrame.attr('src', tripPlannerUrl);
  }
  $('#trip-modal').modal('show');

	sendOpenModalMessage(baseUrl);
}

async function sendOpenModalMessage(baseUrl) {
  // Wait for trip planner to have loaded up
  await hasIframeLoaded();

	// Send message to iframe to reload trip
  const iframe = document.getElementById('trip-frame');
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage('modal-open', baseUrl + '/');
  }
}

async function hasIframeLoaded() {
  if(window.loadedIframe) {
    return Promise.resolve();
  }

  const iframe = $('#trip-frame');

  // Wait for the iframe to load
  return new Promise((resolve, reject) => {
    iframe.on("load", () => {
      window.loadedIframe = true;
      resolve();
    })
  });
}

